import React, {Fragment} from 'react'
import styles from './Actions.scss'
import cx from 'classnames'
import {Link} from 'react-router'
import {SHARE_DIALOG} from 'common/ShareDialog'
import {EXPORT_DIALOG} from '../dialogs/ExportDialog'
import {REPLACE_ELEVATION_MODAL} from 'common/modals/ReplaceElevationModal'
import {COPY_ROUTE_DIALOG} from '../dialogs/CopyRouteDialog'
import {DELETE_DIALOG} from '../dialogs/DeleteDialog'
import {PopoverLinkMenu, PopoverLinkMenuItem as MenuItem, PopoverLinkMenuHeading as MenuHeading} from 'common/styleguide/PopoverLinkMenu'
import {Icon} from 'common/Icon'
import queryString from 'query-string'
// used for modern "Modals" only, not Dialogs!
import {showModal} from 'lib/modalUtils'

const PIN_UPSELL_DIALOG = 'PIN_UPSELL_DIALOG'

export class Actions extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      showMore: false
    }
  }

  toggleMore = () => { this.setState({showMore: !this.state.showMore}) }

  togglePin = () => {
    const {r, currentUser, pinRoute, unpinRoute} = this.props
    if (!currentUser.id) {
      this.showDialog(PIN_UPSELL_DIALOG)
      return
    }
    r.pinned ? unpinRoute(r.id) : pinRoute(r.id)
  }

  showDialog = (dialog) => {
    this.setState({showMore: false})
    this.props.showDialog(dialog)
  }

  showModal = (modal, props) => {
    this.setState({showMore: false})
    showModal(modal, props)
  }

  printMapClicked = () => {
    this.setState({showMore: false})
    this.props.printRoute()
  }

  render () {
    const {r, currentUser, mini, editable} = this.props
    const {showMore} = this.state

    if (mini) {
      return (
        <div className={styles.ActionsMini}>
          <ActionLink data-tip title={r.pinned ? 'Pinned: click to un-pin' : 'Pin this route'} onClick={this.togglePin}>
            <Icon i='pin' />
          </ActionLink>
          <ActionLink onClick={() => this.showDialog(SHARE_DIALOG)}>
            <Icon i='md-share' />
          </ActionLink>
          {editable && <ActionLink href={`/routes/${r.id}/edit`}>
            <Icon i='md-create' />
          </ActionLink>}
        </div>
      )
    }

    const classicQuery = {
      ...queryString.parse(window.location.search),
      beta: 'false',
      privacy_code: ((r.user.id !== currentUser.id) && r.privacyCode) || undefined
    }
    const classicMode = `/routes/${r.id}?${queryString.stringify(classicQuery)}`

    return (
      <div className={cx(styles.Actions, styles.FlexActions)}>
        <div className={styles.flexLink}>
          <ActionLink onClick={this.togglePin} data-tip title={r.pinned ? 'Pinned: Click to un-pin' : 'Pin this route'}>
            {r.pinned === true
              ? <span><Icon i='pin' /> Pinned</span>
              : <span><Icon i='pin' /> Pin</span>}
          </ActionLink>
        </div>
        <div className={styles.flexLink}>
          <ActionLink onClick={() => this.showDialog(SHARE_DIALOG)}>
            <Icon i='md-share' /> Share
          </ActionLink>
        </div>
        {editable && <div className={styles.flexLink}>
          <ActionLink href={`/routes/${r.id}/edit`}>
            <Icon i='md-create' /> Edit
          </ActionLink>
        </div>}
        <div className={cx(styles.flexLink, styles.moreLink)}>
          <ActionLink ref={r => { this._more = r }} className={cx(styles.more, showMore && styles.active)} onClick={this.toggleMore}>
            More <Icon i='ios-arrow-down' />
          </ActionLink>
        </div>

        {showMore && <PopoverLinkMenu
          container={window.body}
          target={this._more}
          placement='bottom'
          onRequestClose={this.toggleMore}>
          <MenuItem href={classicMode}>View in Classic Mode</MenuItem>
          <MenuItem onClick={() => this.showDialog(EXPORT_DIALOG)}>Export as File</MenuItem>
          <MenuItem onClick={this.printMapClicked}>Print Map & Cue PDF</MenuItem>
          <MenuItem href={`/routes/${r.id}/cue_sheet`} target='_blank'>Print Cuesheet</MenuItem>
          {currentUser.id && r && r._permissions.can_be_copied && <MenuItem onClick={() => this.showDialog(COPY_ROUTE_DIALOG)}>Copy to My Routes</MenuItem>}
          {editable && <Fragment>
            <MenuHeading>Private Actions</MenuHeading>
            <MenuItem onClick={() => this.showModal(REPLACE_ELEVATION_MODAL, {troute: r, objectType: 'route'})}>Replace Elevation Data</MenuItem>
            <MenuItem onClick={() => this.showDialog(DELETE_DIALOG)}>Delete</MenuItem>
          </Fragment>}
        </PopoverLinkMenu>}
      </div>
    )
  }
}

class ActionLink extends React.PureComponent {
  render () {
    const {className, tooltip, ...props} = this.props
    const LinkComponent = props.to ? Link : 'a'
    return (
      <LinkComponent {...props} className={cx(styles.action, className)} />
    )
  }
}
